/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

/* eslint-disable no-template-curly-in-string */

// !!! CommonJS format intended
// It's used by NodeJS server as well

/**
 * @param {string} placeholder
 * @param {string} defaultValue
 */
const parseEnv = (placeholder, defaultValue) => {
  const isNode =
    typeof process !== 'undefined' && process.versions && process.versions.node;

  if (placeholder.startsWith('${env.')) {
    // If on NodeJS (${env.XXXX} placeholders are not usually replaced), then load envvars dynamically
    const envVarName = placeholder.replace('${env.', '').replace('}', '');
    if (isNode) {
      return process.env[envVarName] || defaultValue;
    }

    return process.env[`REACT_APP_${envVarName}`] || defaultValue;
  }

  // placeholder may have been replaced by an empty string (no envvar defined), thus we take the default
  // value in that case.
  return placeholder || defaultValue;
};

const PUBLIC_URL = parseEnv(
  '${env.PUBLIC_URL}',
  'https://source-admin.substance3d.com'
);

exports.PUBLIC_URL = PUBLIC_URL;
exports.BASE_URL = PUBLIC_URL;

exports.API_URL = parseEnv(
  '${env.API_URL}',
  'https://source-api-develop.dev.substance3d.io'
);

exports.GRAPHQL_URL = `${this.API_URL}/beta/graphql`;

exports.ALLEGORITHMIC_API_URL = parseEnv(
  '${env.CORPORATE_WEBSITE_API_URL}',
  'https://store.substance3d.com/api/v1'
);

exports.ALLEGORITHMIC_API_TOKEN = parseEnv(
  '${env.CORPORATE_WEBSITE_API_TOKEN}',
  null
);

exports.SOURCE_URL = parseEnv(
  '${env.SOURCE_URL}',
  'https://substance3d.adobe.com/assets'
);

exports.CDN_URL = parseEnv('${env.CDN_URL}', 'https://cdn.allegorithmic.com');

exports.ADOBEID_CLIENT_ID = parseEnv(
  '${env.ADOBEID_CLIENT_ID}',
  'substance-source'
);

exports.IMSLIB_URL = parseEnv(
  '${env.IMSLIB_URL}',
  'https://static.adobelogin.com/imslib/stg1/imslib.js'
);

exports.IS_PRODUCTION = parseEnv('${env.IS_PRODUCTION}', 'false') === 'true';
